<template>
<div>
  <div class="card head-card" >
    <div class="title-card">
      <h4>{{ title2 }}</h4>
    </div>
    <div class="card-content">
      <!-- {{ mediaArr }}-->
    <div class="checkbox todoBar">
        <label class="active todoList">
          <div class="user-avatar selectAll">
            <div class="data-avatar whiteText">Todo</div>
          </div>
          <input class="box" type="checkbox" :checked="allCheck2" @click="selectAllfav()" />

          <span class="nbox">
            <svg viewBox="0 0 14.018 13.003">
              <path
                id="Rectángulo_9"
                data-name="Rectángulo 9"
                d="M304.98,386.9s1.489,1.413,3.5,3.546c4.553-2.794,10.514-9.457,10.514-9.457l-10.514,13Z"
                transform="translate(-304.98 -380.994)"
                fill="#fff"
              />
            </svg>
          </span>
        </label>
      </div>
      <div class="row">
        <div
            class="checkbox image col-md-6 col-sm-12 col-lg-4"
            v-for="(item, index) in data2"
            v-bind:key="item.key"
          >
          <label :for="item.key">
            <div class="btn-img">
              <!--<img :src="getImage(item)" />-->
              <img :src="getImage(item)"  @error="replaceByDefault" class="avatarMin"/><!--NAYE-->
            </div>
            <input
              class="box"
              type="checkbox"
              :id="item.key"
              :value="item.key"
              :checked="findID(item.key) || allCheck2"
              @click="selectMediaFavs(item.key, $event)"
            />
            {{ item.nombre.length>25? item.nombre.slice(0,25)+'...' :item.nombre }}
            <span class="nbox">
              <svg viewBox="0 0 14.018 13.003">
                <path
                  id="Rectángulo_9"
                  data-name="Rectángulo 9"
                  d="M304.98,386.9s1.489,1.413,3.5,3.546c4.553-2.794,10.514-9.457,10.514-9.457l-10.514,13Z"
                  transform="translate(-304.98 -380.994)"
                  fill="#fff"
                />
              </svg>
            </span>
          </label>
        </div>
      </div>
      <div class="button-circle-more primary" v-if="more2" @click="getMoreFav(tMedia)">
        <button class="circle-more">
          <svg viewBox="0 0 18 18">
            <g id="Grupo_29" data-name="Grupo 29" transform="translate(-171 -753)">
              <rect
                id="Rectángulo_redondeado_903"
                data-name="Rectángulo redondeado 903"
                width="2"
                height="18"
                rx="1"
                transform="translate(179 753)"
              />
              <rect
                id="Rectángulo_redondeado_903_copia"
                data-name="Rectángulo redondeado 903 copia"
                width="18"
                height="2"
                rx="1"
                transform="translate(171 761)"
              />
            </g>
          </svg>
        </button>
      </div>
    </div>
  </div>
  <div class="card head-card">
    <div class="title-card">
      <h4>{{ title }}</h4>
    </div>
    <div class="card-content">
      <span style="display: flex; align-items: center;">
        <input class="input-text" type="text" placeholder="Buscar Canal" style="height: 24px; min-height: 20px; max-height: 28px; width: 200px; font-size: 13px; margin: 0 8px; padding: 2px 6px; border-radius: 4px; border: 2px solid #00B99E;" v-model="inSearch" />
        <button @click="feedsSearch" style="background: none; border: none; padding: 0; cursor: pointer; display: flex; align-items: center;">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#00B99E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
        </button>
      </span>
      <!-- {{ mediaArr }}-->
      <div class="checkbox todoBar">
        <label class="active todoList">
          <div class="user-avatar selectAll">
              <div class="data-avatar whiteText">Todo</div>
          </div>
          <input class="box" type="checkbox" :checked="allCheck" @click="selectAll()" />

          <span class="nbox">
            <svg viewBox="0 0 14.018 13.003">
              <path
                id="Rectángulo_9"
                data-name="Rectángulo 9"
                d="M304.98,386.9s1.489,1.413,3.5,3.546c4.553-2.794,10.514-9.457,10.514-9.457l-10.514,13Z"
                transform="translate(-304.98 -380.994)"
                fill="#fff"
              />
            </svg>
          </span>
        </label>
      </div>
      <div class="row">
        <div
            class="checkbox image col-md-6 col-sm-12 col-lg-4"
            v-for="(item, index) in data"
            v-bind:key="item.key"
          >
          <label :for="item.key">
            <div class="btn-img">
               <img :src="getImage(item)"  @error="replaceByDefault" class="avatarMin"/><!--NAYE-->
              <!-- naye--->
            </div>
            <input
              class="box"
              type="checkbox"
              :id="item.key"
              :value="item.key"
              :checked="findID(item.key) || allCheck"
              @click="selectMedia(item.key, $event)"
            />
            {{ item.nombre.length>25? item.nombre.slice(0,25)+'...' :item.nombre }}
            <span class="nbox">
              <svg viewBox="0 0 14.018 13.003">
                <path
                  id="Rectángulo_9"
                  data-name="Rectángulo 9"
                  d="M304.98,386.9s1.489,1.413,3.5,3.546c4.553-2.794,10.514-9.457,10.514-9.457l-10.514,13Z"
                  transform="translate(-304.98 -380.994)"
                  fill="#fff"
                />
              </svg>
            </span>
          </label>
        </div>
      </div>
      <div class="button-circle-more primary" v-if="more" @click="getMore(tMedia)">
        <button class="circle-more">
          <svg viewBox="0 0 18 18">
            <g id="Grupo_29" data-name="Grupo 29" transform="translate(-171 -753)">
              <rect
                id="Rectángulo_redondeado_903"
                data-name="Rectángulo redondeado 903"
                width="2"
                height="18"
                rx="1"
                transform="translate(179 753)"
              />
              <rect
                id="Rectángulo_redondeado_903_copia"
                data-name="Rectángulo redondeado 903 copia"
                width="18"
                height="2"
                rx="1"
                transform="translate(171 761)"
              />
            </g>
          </svg>
        </button>
      </div>
    </div>
  </div>
  </div>
</template>
<script>
// @ is an alias to /src
import axios from "axios";
import _ from "lodash";

export default {
  name: "tmedia",
  components: {},
  data: () => ({
    
    data: [],
    data2: [],
    mediaArr: [],
    mediaArr2: [],
    mediaJoin:[],
    fiParams: [1,1],
    title: "",
    title2: "",
    allCheck: false,
    more: false,
    more2: false,
    allCheck2:false,
    lek2: null,
    lek: null,
    tMedia: "",
    pd: false,
    dataSearch: [],
    inSearch: ""
  }),
  props: ["media"],
  computed: {
    url(){
      return this.$store.getters.getMainUrl;
    },
    token(){
      return this.$store.getters.getToken;
    },
    providerID(){
      return this.$store.state.userInfo.net;
    },
    userVisible() {
      if (this.dataUser.length > 0) {
        return true;
      } else {
        return false;
      }
    },
    allCheckFn() {
      if (this.mediaArr.length > 0) {
        return false;
      } else {
        return true;
      }
    }
  },

  methods: {
     // --------------- naye ----------------
    getImage(item) {
      if (item.imagen) {
        return item.imagen;
      }else{
        return item.img;
      }
    },
    //naye
    replaceByDefault(e){
           console.log("############,pauuuul",this.$store.state.defaultImage)
      var img = this.$store.state.defaultNote;
      switch(this.media){
        case  'T':  img = this.$store.state.defaultTV; break;
        case  'R':  img = this.$store.state.defaultRadio; break;
        default : img = this.$store.state.defaultImage; break;
      }
      e.target.src = img;
    },
    findAll() {},
    selectAll() {
      console.log(this.allCheck);
      if (this.allCheck == false) {
        this.allCheck = true;
        this.mediaArr = [];
          //join arrays
        this.mediaJoin =   _.union( this.mediaArr,  this.mediaArr2);
        let data = {
          mt: this.media,
          arr: this.mediaJoin
        };

      
        this.$store.commit("addMedia", data);
        this.fiParams[1] = 1;
        this.fiParams[0] = this.allCheck2? 1:0;
        this.addfiParams();
      } else {
        this.allCheck = false;
        this.mediaArr = [];
          //join arrays
           this.mediaJoin =   _.union( this.mediaArr,  this.mediaArr2);
        let data = {
          mt: this.media,
          arr: this.mediaJoin
        };
         
        this.$store.commit("addMedia", data);
        this.fiParams[1] = 0;
        this.fiParams[0] = this.allCheck2? 1:0;
        this.addfiParams();
      }
    },
    selectAllfav() {
      if (this.allCheck2 == false) {
        this.allCheck2 = true;
      
         this.mediaArr2 = [];
          //join arrays
           this.mediaJoin =   _.union( this.mediaArr,  this.mediaArr2);
        let data = {
          mt: this.media,
          arr: this.mediaJoin
        };

       
        this.$store.commit("addMedia", data);
         this.fiParams[0] = 1;
         this.fiParams[1] = this.allCheck? 1:0;
         this.addfiParams();
      } else {
        this.allCheck2 = false;
        this.mediaArr2 = [];
         //join arrays
          this.mediaJoin =   _.union( this.mediaArr,  this.mediaArr2);
        let data = {
          mt: this.media,
          arr: this.mediaJoin
        };
         
        this.$store.commit("addMedia", data);
         this.fiParams[0] = 0;
         this.fiParams[1] = this.allCheck? 1:0;
         this.addfiParams();
      }
    },
    addToStore() {
      this.mediaJoin =   _.union( this.mediaArr,  this.mediaArr2);
      let data = {
        mt: this.media,
        arr: this.mediaJoin
      };
      this.$store.commit("addMedia", data);
      console.log('fiList');
      console.log(this.$store.state.projectConfig.fiList[this.media]);
    },
    addfiParams(){
      console.log('addfiParams');
      
       let data = {
        mt: this.media,
        arr: this.fiParams
      };
      console.log(data);
      this.$store.commit("addfiParams", data);
    },
    removeItem(media) {
      var index = this.mediaArr.indexOf(media);
      if (index > -1) {
        this.mediaArr.splice(index, 1);
      }

      this.addToStore();
    },
      removeItem2(media) {
      var index = this.mediaArr2.indexOf(media);
      if (index > -1) {
        this.mediaArr2.splice(index, 1);
      }

      this.addToStore();
    },
    selectMedia(media, element) {
      console.log('selectMedia');
      console.log(element.target.checked);
      if (this.allCheck == true) {
        this.allCheck = false;
        this.mediaArr = [];
       
        element.target.checked = true;
      }

      if (element.target.checked == true) {
        console.log('agregamos')
        this.mediaArr.push(media);
         this.fiParams[1] = 0;
         this.fiParams[0] = this.allCheck2?1:0;
         this.addfiParams();
        this.addToStore();

        
      } else {
        console.log('removemos')
        this.removeItem(media);
       
      }
    },
    selectMediaFavs(media, element) {
      if (this.allCheck2 == true) {
        this.allCheck2 = false;
        this.mediaArr2 = [];
        element.target.checked = true;
      }

      if (element.target.checked == true) {
     
        this.mediaArr2.push(media);
        this.addToStore();
      

         this.fiParams[0] = 0;
         this.fiParams[1] = this.allCheck?1:0;
         this.addfiParams();
      } else {
        this.removeItem2(media);
      }
    },
    getMore(mediaType) {
      switch (mediaType) {
        case "T":
          this.getTmedia("T");
          
          break;

        case "R":
          this.getTmedia("R");

          break;

        case "PD":
          this.getNMedia();

          break;

        default:
          break;
      }
    },
    getMoreFav(mediaType) {
      switch (mediaType) {
        case "T":
          this.getTfavs("T");

          break;

        case "R":
          this.getTfavs("R");

          break;

       case "PD":
          this.getNFavs("rss");

        break;

        default:
          break;
      }
    },
    removeSame(){
      console.log('removeSame');
      console.log(this.data2);
      var that = this;
   for (let i = 0; i < that.data2.length; i++){
          var key = that.data2[i].key;
          let index = _.findIndex(that.data, function(o) { return o.key == key; });
            
      if (index > -1) {
        that.data.splice(index, 1);
      }
          }
    },
      getTfavs(type) {
        console.log('getTfavs');
      var that = this;

      if (this.more2 == true) {
        var dat = JSON.stringify({
          limit: 20,
          medio: type,
          token: that.token,
          LastEvaluatedKey: that.lek2,
          
        });
      } else {
        var dat = JSON.stringify({
          limit: 20,
          medio: type,
            token: that.token
        });
      }

      console.log(type);
      axios
        .post(
          that.url + "getNoticierosFavUser",
          dat
        )
        .then(function(response) {
          
          that.data2 = _.concat(that.data2, response.data.result);
          // that.data = response.data.result;

       that.removeSame();

          console.log(that.data2);

          if (response.data.LastEvaluatedKey) {
            that.lek2 = response.data.LastEvaluatedKey;
            that.more2 = true;
            that.tMedia = type;
          } else {
            that.lek2 = null;
            that.more2 = false;
          }
        })
        .catch(function(error) {
          console.log("Error");
          console.log(error);
        });
    },
    getNfavs(type) {
        console.log('getNfavs');
      var that = this;

      if (this.more2 == true) {
        var dat = JSON.stringify({
          limit: 20,
          feed: type,
          token: that.token,
          LastEvaluatedKey: that.lek2,
          providerID : that.providerID
        });
      } else {
        var dat = JSON.stringify({
          limit: 20,
          feed: type,
          token: that.token,
          providerID : that.providerID
        });
      }

      console.log(type);
      axios
        .post(
          that.url + "getUserFeeds",
          dat
        )
        .then(function(response) {
          console.log(response);
          that.data2 = _.concat(that.data2, response.data.result);
          // that.data = response.data.result;

          that.removeSame();

          console.log(that.data2);

          if (response.data.LastEvaluatedKey) {
            that.lek2 = response.data.LastEvaluatedKey;
            that.more2 = true;
            that.tMedia = type;
          } else {
            that.lek2 = null;
            that.more2 = false;
          }
        })
        .catch(function(error) {
          console.log("Error");
          console.log(error);
        });
    },
    getTmedia(type) {
      console.log('getTmedia')
      var that = this;

      if (this.more == true) {
        var dat = JSON.stringify({
          limit: 20,
          medio: type,
          LastEvaluatedKey: that.lek
        });
      } else {
        var dat = JSON.stringify({
          limit: 20,
          medio: type
        });
      }

      console.log("poooooooo",this.url);
      axios
        .post(
         that.url + "getProgramas",
          dat
        )
        .then(function(response) {
          console.log(response.data.result);
          that.data = _.concat(that.data, response.data.result);
          // that.data = response.data.result;
          console.log('that.more',that.more);
           if (that.more != true){
             that.getTfavs(type);
          }else{
               that.removeSame();
          }
          console.log(that.data);
          if (response.data.LastEvaluatedKey) {
            that.lek = response.data.LastEvaluatedKey;
            that.more = true;
            that.tMedia = type;
          } else {
            that.lek = null;
            that.more = false;
          }

         

      

        })
        .catch(function(error) {
          console.log("Error");
          console.log(error);
        });
    },
    getNMedia() {
      var that = this;

      if (this.more == true) {
        var dat = JSON.stringify({
          limit: 20,

          LastEvaluatedKey: that.lek
        });
      } else {
        var dat = JSON.stringify({
          limit: 20
        });
      }
      axios
        .post(
          that.url + "getRSSsrc",
          dat
        )
        .then(function(response) {
          that.data = _.concat(that.data, response.data.result);
          console.log(that.data);
          if (that.more != true){
             that.getNfavs('rss');
          }else{
               that.removeSame();
          }

          if (response.data.LastEvaluatedKey) {
            that.lek = response.data.LastEvaluatedKey;
            that.more = true;
            that.tMedia = "PD";
          } else {
            that.lek = null;
            that.more = false;
          }
        })
        .catch(function(error) {
          console.log("Error");
          console.log(error);
        });
    },
    getFeedsSearch(mediaType) {
      var that = this;

      axios.post(
          that.url + "getFeedsSearch",
          {
            src: mediaType,
            token: that.providerID
          }
        )
        .then(function(response) {
          that.dataSearch = response.data.data;
        })
        .catch(function(error) {
          console.log("Error");
          console.log(error);
        });
    },
    feedsSearch() {

      var input, filter, ul, li, a, i, txtValue;
      input = event.target;
      filter = this.inSearch.toUpperCase();
      console.log('filter',filter);
      console.log(this.dataSearch);
      this.data = this.dataSearch.filter(function(item) {
        console.log('item.nombre',item.nombre);
        if (item.nombre.toUpperCase().indexOf(filter) > -1) {
          return true;
        } else {
          return false;
        }
      });
      //console.log('data filtrada',this.data);
    },
    getOwnFeed(network) {
      var that = this;
      var dat = JSON.stringify({
        feed: network,
        token: this.token
      });
    },
    findID(id) {
      /*console.log('findID');
      console.log(this.$store.state.projectConfig.fiList[this.media]);
      console.log(id);*/
      if(this.$store.state.projectConfig.fiList[this.media].indexOf(id)>=0){
        return true;
      }else{
        return false;
      }
      
      /*var found = this.mediaJoin.find(function(element) {
        console.log('element',element);
        if (element == id) {
          return true;
        } else {
          return false;
        }
      });
      return found;*/
    },
    findID2(id) {
      var found = this.mediaArr2.find(function(element) {
        if (element == id) {
          return true;
        } else {
          return false;
        }
      });
      return found;
    },
    
  },

  beforeMount() {
    console.log('beforeMount tmedia####');

    switch (this.media) {
      case "T":
      
        this.getTmedia("T");
        this.getFeedsSearch("T");
        
        this.title = "Lista de programas de televisión";
         this.title2 = "Mis canales";
        break;

      case "R":
      
        this.getTmedia("R");
        this.getFeedsSearch("R");
        this.title = "Lista de programas de radio";
         this.title2 = "Mis canales";
        break;

      case "PD":
        this.getNMedia();
        this.getFeedsSearch("PD");
        this.pd = true;
        this.title = "Lista de portales de noticias";
         this.title2 = "Mis Portales de noticias" ;
        break;

      default:
        break;
      //this.defaultImg = this.$store.state.defaultNoticiero;
    }

   /* this.mediaArr = this.$store.state.projectConfig.fiList[this.media];
    console.log("MEddiaArr");
    console.log(this.mediaArr);
    if (this.mediaArr[0] == "all" || this.mediaArr.length == 0) {
      this.selectAll();
    }
    console.log(this.mediaArr[0]);*/
    this.mediaJoin = this.$store.state.projectConfig.fiList[this.media];
    let param = this.$store.state.projectConfig.fiParams[this.media];

    var combinacion = param[0] + '' + param[1];
    //if ((param[0] == 1 && param[1] == 1) || this.mediaJoin.length == 0) {
    switch(combinacion){
      case '01':
        this.selectAll();
      break;
      case '10':
        this.selectAllfav();
      break;
      case '11':
        this.selectAll();
        this.selectAllfav();
      break;
      default : break;
    }
  },
  mounted() {},
  updated() {}
};
</script>

<style lang="scss">
.data-avatar {
  margin-right: 5px;
}

.whiteText {
  color: #062633;
}
.todoList {
  background-color: #ffffff !important;
  border-bottom: 1px solid #00b99e !important;
  border-radius: 0px !important;
}

.todoBar label input:checked + .nbox {
  background-color: #00b99e;
}
</style>
